/**
 * Inbox nav rows follow Linear's sidebar metrics: 28px row, 8px radius,
 * 14px icon, 6px icon-to-label gap, 13px/500 label, 11px count.
 * Built-in tabs and saved views render from different components, so the
 * geometry lives here to keep the two columns identical.
 */
export const INBOX_NAV_ROW =
	"flex h-7 items-center justify-between gap-1.5 rounded-lg pl-[7px] pr-[6px] text-[13px] font-medium leading-4"

/** The light nav sits on gray-50, so hover and active each need a full step to read. */
export const INBOX_NAV_ROW_ACTIVE = "bg-gray-200 text-primary dark:bg-gray-800"

/** Linear's dark nav gray is neutral; our gray-400 is blue-tinted, so it is set exactly here. */
const INBOX_NAV_GRAY = "text-gray-600 dark:text-[#919294]"

export const INBOX_NAV_ROW_INACTIVE = `${INBOX_NAV_GRAY} hover:bg-gray-150 hover:text-primary dark:hover:bg-gray-800/50`

/** Icon and label share one color so both track the row's active state. */
export const INBOX_NAV_LEAD = "flex min-w-0 items-center gap-1.5"

export const INBOX_NAV_ICON = "size-3.5 flex-none"

/** The count sits one gray step lighter than the label, in both row states. */
export const INBOX_NAV_COUNT =
	"text-[11px] tabular-nums text-gray-500 dark:text-gray-450"

/**
 * Section labels read like Finder's sidebar headings: a step bolder and a step dimmer than the rows.
 * The whole header row takes the rows' hover, like Linear's; the label keeps its 6px inset.
 */
export const INBOX_NAV_SECTION_HEADER =
	"h-7 rounded-lg pl-0 pr-0.5 text-gray-450 hover:bg-gray-150 dark:text-gray-500 dark:hover:bg-gray-800/50 [&>button]:pl-1.5 [&_span]:font-semibold"

export const INBOX_NAV_GROUP = "flex flex-col gap-px"

/** The empty-state add button sits in the row column, so it takes the row's metrics. */
export const INBOX_NAV_ADD_BUTTON =
	"h-7 gap-1.5 pl-[7px] pr-[6px] text-[13px] font-medium"

/** Mobile renders the sidebar as a horizontal strip, so the row unlocks there. */
export const INBOX_NAV_ROW_MOBILE =
	"max-sm:h-auto max-sm:shrink-0 max-sm:justify-start max-sm:gap-2 max-sm:whitespace-nowrap max-sm:py-2 max-sm:pl-3 max-sm:pr-2.5 max-sm:text-sm"

export const VIEW_ICON_CLASS =
	"h-3.5 min-h-3.5 w-3.5 min-w-3.5 flex-none stroke-[1.75] opacity-100"
